import { createSlice } from '@reduxjs/toolkit';

import { RootState } from 'src/app/store/types';
import {
  GeoLocationRead,
  SourceEnum,
  TagRead,
} from 'src/common/external/bambi-api/bambiApi';

export interface SettingState {
  tags: TagRead[];
  selectedTag: TagRead | undefined;
  tagSearchTerm: string;
  showTagsModal: boolean;
  showDeleteTagModal: boolean;
  selectedGeolocation: GeoLocationRead | undefined;
  geolocationSearchTerm: string;
  showGeolocationModal: boolean;
  showArchivedGeolocations: boolean;
  geolocationSourceFilter: SourceEnum[];
}

export const initialState: SettingState = {
  tags: [],
  selectedTag: undefined,
  tagSearchTerm: '',
  showTagsModal: false,
  showDeleteTagModal: false,
  selectedGeolocation: undefined,
  geolocationSearchTerm: '',
  showGeolocationModal: false,
  showArchivedGeolocations: false,
  geolocationSourceFilter: [],
};

export const settingSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSelectedTag: (state, action) => {
      state.selectedTag = action.payload;
    },
    setTagSearchTerm: (state, action) => {
      state.tagSearchTerm = action.payload;
    },
    setShowTagsModal: (state, action) => {
      state.showTagsModal = action.payload;
    },
    setShowDeleteTagModal: (state, action) => {
      state.showDeleteTagModal = action.payload;
    },
    setSelectedGeolocation: (state, action) => {
      state.selectedGeolocation = action.payload;
    },
    setGeolocationSearchTerm: (state, action) => {
      state.geolocationSearchTerm = action.payload;
    },
    setShowGeolocationModal: (state, action) => {
      state.showGeolocationModal = action.payload;
    },
    setShowArchivedGeolocations: (state, action) => {
      state.showArchivedGeolocations = action.payload;
    },
    setGeolocationSourceFilter: (state, action) => {
      state.geolocationSourceFilter = action.payload;
    },
  },
});

export const {
  setSelectedTag,
  setTagSearchTerm,
  setShowTagsModal,
  setShowDeleteTagModal,
  setSelectedGeolocation,
  setShowGeolocationModal,
  setGeolocationSearchTerm,
  setShowArchivedGeolocations,
  setGeolocationSourceFilter,
} = settingSlice.actions;

export const selectGeolocationSearchTerm = (state: RootState) =>
  state.setting.geolocationSearchTerm;

export const selectGeolocationSourceFilter = (state: RootState) =>
  state.setting.geolocationSourceFilter;
